var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoryWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.64 18.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.65,2.96h-7.43l-2.24-2.19c-.31-.33-.82-.77-1.62-.77H3.72c-.66,0-1.43.26-1.67.85l-.69,2.22c-.79.26-1.37,1-1.37,1.88v11.65c0,1.09.89,1.98,1.98,1.98h18.67c1.1,0,1.98-.89,1.98-1.98V4.95c0-1.09-.89-1.98-1.98-1.98ZM3.72.81h5.65c.17,0,.4.05.77.45l1.74,1.71H2.49l.59-1.9c.06-.16.37-.25.64-.25ZM21.6,16.59c0,.52-.42.95-.95.95H1.98c-.52,0-.95-.42-.95-.95V4.95c0-.52.42-.95.95-.95h18.67c.52,0,.95.42.95.95v11.65Z",
    fill: "#ffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryWhite);
export default __webpack_public_path__ + "static/media/history_white.12bea79fd85a2688c35c92c28cda85cd.svg";
export { ForwardRef as ReactComponent };